import React from "react";
import { GiBowTieRibbon } from "react-icons/gi";
import SharedCS from "./SharedCS";
import styles from "./Giftwrap.module.css";
import GiftWrapItem from "../../Components/CustomerServices/GiftWrapItem";
import ShopActions from "../../Components/Shared/ShopActions/ShopActions";
import commonStyles from "../../Components/Shared/commonStyles.module.css";
import GiftTagAdvice from "../../Components/CustomerServices/GiftWrap/GiftTagAdvice";
import PersonalisationCTA from "../../Components/CustomerServices/Personalisation/PersonalisationCTA";
import GiftWrapWhy from "../../Components/CustomerServices/GiftWrap/GiftWrapWhy";

const Giftwrap = () => (
  <div className={commonStyles.section}>
    <div className={commonStyles.container}>
      <div className={commonStyles.sectionHeaderContainer}>
        <h2 className={commonStyles.sectionHeader}>
          Luxury Gift Wrapping, Ready to Give
        </h2>
        <p className={commonStyles.paragraph}>
          Every gift and hamper can be beautifully wrapped with our signature tissue
          paper, finished with a luxury ribbon and a personalised gift tag,
          ready to delight your recipient. Our service saves you time and
          ensures every gift looks perfect - all prepared right here in Jersey.
        </p>
      </div>
      <div className={styles.GiftwrapContent}>
      <img
        src="/Images/Content/CustomerServices/GiftWrap/Wrapping.jpg"
        alt="Giftwrap"
        className={styles.GiftwrapImg}
      />
    </div>
      <GiftTagAdvice />
      <GiftWrapWhy />
       <PersonalisationCTA />
    </div>
    
  </div>
);

export default Giftwrap;
